import axios from "../http";

class Model {
  warehouseList() {
    const url = `/zwy/api/wx/sign/warehouse/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  laborList(warehouseId) {
    const url = `/zwy/api/wx/sign/labor/list?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //打卡
  sign(data) {
    const url = `/zwy/api/wx/sign/clock`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //已打卡临时工列表
  tempList(warehouseId, type) {
    const url = `/zwy/api/wx/sign/temp/list?warehouseId=${warehouseId}&type=${type}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //获取临时工部门列表
  deptList(warehouseId) {
    const url = `/zwy/api/wx/sign/dept/list?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //临时工点名
  signCheck(data) {
    const url = `/zwy/api/wx/sign/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Model;